import { CSSProperties, SVGProps } from 'react';

import { COLORS } from '../../../lib';

interface ICrossIconProps extends SVGProps<SVGSVGElement> {
  color?: CSSProperties['color'];
}

export const CrossIcon = ({ color, ...props }: ICrossIconProps) => {
  const fill = color ?? COLORS['icon-base-500'];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M5.02878 3.9801C4.7392 3.69052 4.26969 3.69052 3.98011 3.9801C3.69052 4.26968 3.69053 4.73919 3.98011 5.02877L6.95134 8L3.98011 10.9712C3.69053 11.2608 3.69052 11.7303 3.98011 12.0199C4.26969 12.3095 4.73919 12.3095 5.02878 12.0199L8.00001 9.04867L10.9712 12.0199C11.2608 12.3095 11.7303 12.3095 12.0199 12.0199C12.3095 11.7303 12.3095 11.2608 12.0199 10.9712L9.04868 8L12.0199 5.02877C12.3095 4.73919 12.3095 4.26968 12.0199 3.9801C11.7303 3.69052 11.2608 3.69052 10.9712 3.9801L8.00001 6.95133L5.02878 3.9801Z"
        fill={fill}
      />
    </svg>
  );
};
